module.exports = __webpack_public_path__ + "img/arrow_back.b6fdbf16.svg";